import { useCurrentUser } from "@/hooks/useCurrentUser";
import AdminResgates from "@/pages/admin/AdminResgates";
import Resgates from "@/pages/influencer/Resgates";
import SellerResgates from "@/pages/seller/SellerResgates";

export default function ResgatesPage() {
  const { data: user } = useCurrentUser();
  const roles = user?.roles ?? [];
  if (roles.includes("indiqr-admin")) return <AdminResgates />;
  if (roles.includes("indiqr-influenciador")) return <Resgates />;
  return <SellerResgates />;
}
